export var DateMarkerType;

(function (DateMarkerType) {
  DateMarkerType["SquareOutline"] = "square-outline";
  DateMarkerType["RoundOutline"] = "round-outline";
  DateMarkerType["Corner"] = "corner";
})(DateMarkerType || (DateMarkerType = {}));